import React from 'react';
import {
    FaWhatsapp,
    FaSms,
    FaSpinner,
    FaRegSmile,
    FaRegFrown,
    FaFileSignature
} from 'react-icons/fa';
import { MdMail } from 'react-icons/md';

async function trataLink(data) {
    const resultado = await data.map(value => {
        const { FormaEnvio, StatusLink, TipoAceite } = value;

        switch (FormaEnvio) {
        case 1:
            value.FormaEnvio = <FaSms size={25} title={value.TelefoneEnvio} />;
            break;
        case 2:
            value.FormaEnvio = (
                <MdMail size={25} title={value.EmailEnvio} color="blue" />
            );
            break;
        case 3:
            value.FormaEnvio = (
                <FaWhatsapp size={25} title={value.TelefoneEnvio} color="green" />
            );
            break;
        case 4:
            value.FormaEnvio = (
                <FaFileSignature size={25} title={value.AceiteTela} />
            );
            break;
        default:
            break;
        }

        switch (StatusLink) {
        case 1:
            value.StatusLink = (
                <div>
                    <FaSpinner size={25} color="#FFA726" title="Aguardando" />
                    <p>Aguardando</p>
                </div>
            );
            break;
        case 2:
            value.StatusLink = (
                <div>
                    <FaRegSmile size={25} color="green" title="Aprovado" />
                    <p>Aprovado</p>
                </div>
            );
            break;
        case 3:
            value.StatusLink = (
                <div>
                    <FaRegFrown size={25} color="red" title="Cancelado" />
                    <p>Cancelado</p>
                </div>
            );
            break;
        default:
            break;
        }

        switch (TipoAceite) {
        case 1:
            value.TipoAceite = 'Aceite';
            break;
        case 2:
            value.TipoAceite = 'Aceite + Adesão';
            break;
        case 3:
            value.TipoAceite = 'Aceite + Adesão via Cartão + Cobrança Continuada';
            break;
        case 4:
            value.TipoAceite = 'Aceite em tela';
            break;
        case 5:
            value.TipoAceite = 'Aceite + Adesão via Pix+ Cobrança Continuada';
            break;
        case 6:
            value.TipoAceite = 'Aceite + Pix + Débito em conta';
            break;
        case 7:
            value.TipoAceite = 'Aceite + Boleto + Débito em conta';
            break;
        default:
            break;
        }
        
        return value;
    });

    return resultado;
}

export default trataLink;
